import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';

function MyMenuBottomSheet() {
    return (
        <Container fullWidth spacing={32}>
            <Column fullWidth spacing={12}>
                <Text color={colors.gray7} size='lg' fontWeight='bold'>나만의 메뉴명</Text>
                <TextField placeholder='메뉴 이름을 입력해주세요.'/>
                <Text size='s' color={colors.gray6}>해당 메뉴를 MY메뉴로 저장하여 간편하게 주문하세요.</Text>
            </Column>
            <Description spacing={10}>
                <Text color={colors.gray6} fontWeight='bold'>상품명이 노출되는 영역</Text>
                <Text color={colors.gray6}>
                    ICEㅣ일회용컵 사용ㅣL사이즈ㅣ샷추가(+500)ㅣ카라
                    멜마끼아또 시럽추가(+500)ㅣ설탕 시럽추가(+500)
                </Text>
            </Description>
            <Button fullWidth>저장</Button>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px;
`;

const Description = styled(Column)`
    padding: 12px;
    background-color: var(--color-gray2);
    border-radius: 8px;
`;

export default MyMenuBottomSheet;
